import React from "react";
import { useLang } from "@/lib/lang";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { FLAG_BY_LANG } from "@/components/Flags";

export default function LanguageSelector() {
    const { lang, setLang, LANGUAGES } = useLang();
    const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    const CurrentFlag = FLAG_BY_LANG[current.code];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className="mono-label flex items-center gap-1.5 px-2 py-1 hover:text-slate-900 transition-colors"
                    data-testid="lang-selector"
                >
                    <CurrentFlag />
                    {current.label}
                    <ChevronDown size={12} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-slate-50 border-slate-200 min-w-[130px]">
                {LANGUAGES.map((l) => {
                    const Flag = FLAG_BY_LANG[l.code];
                    return (
                        <DropdownMenuItem
                            key={l.code}
                            onClick={() => setLang(l.code)}
                            className="mono-label cursor-pointer focus:bg-slate-100 flex items-center gap-2"
                            data-testid={`lang-option-${l.code}`}
                        >
                            <Flag /> {l.label} — {l.name}
                        </DropdownMenuItem>
                    );
                })}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
